export default __webpack_public_path__ + "static/ai-solutions-with-roadmap5-19e87ee9f5b9709989fa8dcfc6f1f6d4.webp";